import SiDownload from '@/icons/SiDownload';
import { RoleType, useRole } from '@/services/authentication/hooks/user';
import { useDownloadDriveItems } from '@/utils/folder';
import { FC } from 'react';
import { toast } from 'sonner';
import { Button } from '../form/Button';
import { ButtonVariant } from '@/components/form/buttonHelper';
import { SelectionBar } from '../itemSelection/ItemSelection';
import { useModal } from '../modal/useModal';
import DeleteFilesConfirmationModal from './DeleteFilesConfirmationModal';
import { useSelection } from '@/services/selection/useSelectionProvider';

export const FilesExplorerSelectionBar: FC = () => {
  const [selected, clearSelection] = useSelection(state => [state.selected, state.clearSelection]);

  const downloadDriveItems = useDownloadDriveItems();

  const downloadAllItems = async () => {
    try {
      const driveItems = await downloadDriveItems.mutateAsync({ ids: selectedItemIds });
      await Promise.all(
        driveItems.map(async ([url, item]) => {
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', item.name ?? 'ItemName');
          document.body.appendChild(link);
          link.click();

          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);
        })
      );

      toast('Downloaded files');
    } catch (error) {
      console.error('Error occurred while downloading files:', error);
    }
  };

  const selectedItemIds = Array.from(selected);

  const modalProps = useModal();

  const role = useRole();

  return (
    <>
      <DeleteFilesConfirmationModal {...modalProps} />
      {selected.size > 0 && (
        <SelectionBar selectedItemIds={selectedItemIds}>
          <Button variant={ButtonVariant.Mono} onClick={() => clearSelection()}>
            Deselect
          </Button>

          <Button variant={ButtonVariant.Mono} onClick={downloadAllItems}>
            <SiDownload className="text-xl" />
            <span>Download</span>
          </Button>

          {role.type === RoleType.Admin && (
            <Button variant={ButtonVariant.Destructive} onClick={() => modalProps.open()}>
              <span>Delete</span>
            </Button>
          )}
        </SelectionBar>
      )}
    </>
  );
};
